import cn from 'classnames';
import { useEffect, useRef } from 'react';

import { CssQuestionType } from '@webapp/common/components/survey-custom';
import { CDN_URL } from '@webapp/common/conf';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import css from './video-test.css';

export const VideoTest: FC<SurveyQuestion> = ({ question, readOnly, questionBlockPosition }) => {
    const { filePath, responseActor, id } = question;
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (readOnly) return;

        const video = videoRef?.current;

        if (video) {
            let supposedCurrentTime = 0;
            video.addEventListener('timeupdate', function () {
                if (!video.seeking) {
                    supposedCurrentTime = video.currentTime;
                }
            });

            video.addEventListener('seeking', function () {
                const delta = video.currentTime - supposedCurrentTime;
                if (Math.abs(delta) > 0.01) {
                    video.currentTime = supposedCurrentTime;
                }
            });

            video.addEventListener('ended', function () {
                supposedCurrentTime = 0;
                responseActor.send({ type: 'CHANGE', value: true, questionId: id });
            });

            video.addEventListener('contextmenu', (e) => {
                e.preventDefault();
            });
        }
    }, [videoRef.current]);

    if (readOnly) {
        return (
            <video className={css.videoPreview} src={CDN_URL + filePath}>
                Your browser does not support the video tag.
            </video>
        );
    }

    return (
        <div
            className={cn(css.videoTest, CssQuestionType.QUESTION, CssQuestionType.VIDEO_TEST)}
            style={{ textAlign: questionBlockPosition }}
        >
            {filePath ? (
                <video
                    controls={true}
                    ref={videoRef}
                    className={css.video}
                    src={CDN_URL + filePath}
                    disablePictureInPicture={true}
                    controlsList='nodownload noremoteplayback noplaybackrate'
                >
                    Your browser does not support the video tag.
                </video>
            ) : (
                'Нет видео'
            )}
        </div>
    );
};
